import { render, staticRenderFns } from "./view-section-card.vue?vue&type=template&id=6423ea68&"
import script from "./view-section-card.vue?vue&type=script&lang=js&"
export * from "./view-section-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports